import { render } from "./MessagesDemo.vue?vue&type=template&id=19f794a4&scoped=true"
import script from "./MessagesDemo.vue?vue&type=script&lang=js"
export * from "./MessagesDemo.vue?vue&type=script&lang=js"

import "./MessagesDemo.vue?vue&type=style&index=0&id=19f794a4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f794a4"]])

export default __exports__